import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  padding-top: ${({ isModal }) => isModal ? "0" : "32px"};

  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 768px){
    padding: 16px;
  }

  .input-wrapper{
    width: 90%;
  }

  .bordas{
    width: 100%;
    margin-bottom: 20px;
    padding: 20px;
    border: solid 1px #c5cbd6;
    border-radius: 8px;
  }

  .arquivos{
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    label{
      font-size: smaller;
      width: 100%;
      margin-left: 5px;
      text-align: center;
      color: #8a92a2;
    }
    .btn-update{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px;
      border: dashed 1px #8a92a2;
      border-radius: 8px;
    }
    .arq-name{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        transform: rotate(45deg);
        z-index: 10;
      }

      img:hover{
        cursor: pointer;
      }
    }
  }
  
  .legenda {
    font-size: smaller;
    width: 100%;
    margin-left: 5px;
    text-align: center;
  }

  .button-finish {
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  max-width: 880px;

  gap: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;

  >div{
    padding: 0;
  }

  >div>div{
    max-width: 880px;

    >div{
      max-width: 100%;
      padding: 8px 0;

      >div>div{
        padding: 0;

        >div>form{
          margin-top: 0;

          >div>input{
            &:-webkit-autofill {
              -webkit-box-shadow: 0 0 0 30px white inset;
            }
          }

          @media (max-width: 990px){
            >div:nth-of-type(2), 
            >div:nth-of-type(4){
                margin-bottom: 40px;

              >div:last-of-type{
                justify-content: space-between;
              }
            }
          }
        }
      }
    }

    @media (max-width: 768px){
      >div:nth-of-type(2) {
        height: auto !important;

        gap: 16px;
        flex-direction: column;

        >div>div{
          width: 100%;

          >div{
            /* padding: 0 !important; */
            margin: 0 !important;
          }
        }

        >div:nth-of-type(3){
          align-items: flex-start;

          >div{
            width: auto;
          }
        }
      }
    }
  }
`;

export const ContainerContentAcordionClose = styled.div`
    width: 100%;
    height: auto;

    gap: 48px;
    display: flex;
    justify-content: center;
    justify-content: flex-start;
`;

export const InformationAcordionClose = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
`;

export const ContainerCpntentAcordionCard = styled.div`
    width: 100%;
    height: auto;
    padding: 16px 0;

    gap: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 1024px){
      flex-wrap: wrap;
    }

    @media (max-width: 479px){
      gap: 16px;
    }
`;

export const SignatureSection = styled.div`
  width: ${({ isModal }) => isModal ? "100%" : "fit-content"};
  max-width: 100%;
  margin: 0 auto;

  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContainerMethod = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isModal }) => isModal ? `flex-wrap: wrap;` : ``}

  @media (max-width: 768px){
    flex-wrap: wrap;
  }
`;

export const CardPlansHeader = styled.div`
  width: 100%;
  height: auto;
  min-height: 170px;

  gap: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;

  >p:nth-of-type(1){
    text-align: center;
    white-space: nowrap;
  }

  >p:nth-of-type(2){
    text-align: center;
  }

  @media (max-width: 768px){
    min-height: 0;
  }
`;

export const Button = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1rem;
    background-color: #589BFF14;

    >img{
        width: 1.25rem;
        height: 1.25rem;
    }

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;

export const LoadingWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: ${({ isModal }) => isModal ? "360px" : "auto"};
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  margin-top: ${({ isModal }) => isModal ? "0" : "10rem"};

  background-color: transparent;
  border-top: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-bottom: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;